module.exports = __webpack_public_path__ + "img/mobile-character.3ea6f219.webp";